import * as d3 from "d3";
import {parseSvg} from "d3-interpolate/src/transform/parse";
import React, {useEffect, useRef, useState} from "react";
import {DISABLED_COLOR, PRIMARY_COLOR,} from "../../../components/Common/StyleElement";


import {TrackBase} from "../StyledApplication";
import FixedSizeContextMenu from "./Components/FixedSizeContextMenu";
import {tip} from "./Components/Tooltip";
import "./Components/Tooltip.css";
import Drag from "./Service/Drag";
// import dummyData from "./dummyData.json";
import CustomizedColorPicker from "./Components/CustomizedColorPicker";


import {Store} from 'react-notifications-component';
import "react-notifications-component/dist/theme.css";
import "animate.css";
//import {CopyToClipboard} from 'react-copy-to-clipboard';
import {ExtremeFinder} from "./Service/ExtremeFinder";
import Order from "./Service/Order";
import useWindowSize from "./Service/useWindowSize";
// import Zoom from "./Service/Zoom";
import axios from "axios";
import {SEQ_SEARCH, SERVER_URL} from "../../../services/Config";

import Popup from 'reactjs-popup';
import "./Components/Popup.css";
// import PhyloTree from "./Components/Phylod3Tree";


const Tracks = ({ data, meta, recordType, filter, centerCallback, scale,localCenterGene,
                    trackTaxonomy,database,token, relocate,visionMode,zoomLevel,widthLevel }) => {
    const svgRef = useRef(null);
    const [width, height] = useWindowSize();
    // const [svgWidth, svgHeight] = [width - 75, 768 - 25];
    // const [svgWidth, svgHeight] = [width - 75, 768 -20];

    // var [svgWidth, svgHeight] = [width - 75, 768 -20];

    const [svgWidth,setSvgWidth] = useState((width - 75) * 2)
    const [svgHeight,setSvgHeight] = useState(768 -20)



    const [minValue, maxValue] = ExtremeFinder(data);

    const [orders, setOrders] = useState(data.map((d) => d.order));
    const [sortOrder,setSortOrder] = useState([])
    // const [keepOrder,setKeepOrder] = useState([])

    const [curCenterGene, setCurCenterGene] = useState(localCenterGene)
    var keepOrder = [...Array(data.length).keys()]

    const [scrollTop, setScrollTop] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    const [curDatabase,setCurDatabase] = useState(database)
    const [seq,setSeq] = useState('')

    const [open, setOpen] = useState(false);
    const closeModal = () => setOpen(false);

    const contentStyle = { textAlign: 'left' };

    const [detailOpen, setDetailOpen] = useState(false);
    const closeDetailModal = () => setDetailOpen(false);

    const [treeOpen, setTreeOpen] = useState(false);
    const closeTreeModal = () => setTreeOpen(false);


    const [keggDefinitions,setKeggDefinitions] = useState([])
    const [pfamDefinitions,setPfamDefinitions] = useState([])
    const [tigrfamDefinitions,setTigrfamDefinitions] = useState([])
    const [metaDetails,setMetaDetails] = useState({})

    // taxonomy
    // const [curTaxonomy,setCurTaxonomy] = useState(trackTaxonomy)

    // data
    // const [plotData, setPlotData] = useState(null)

    // color picker related
    const [showColorPicker,setShowColorPicker] = useState(false)
    const [curColor, setCurColor] = useState("#fffff")
    const [curColorGene, setCurColorGene] = useState("")
    const [colorPickerPosition,setColorPickerPosition] = useState([0,0,0])

    const [colorSet, setColorSet] = useState(new Set(meta['data'].map((c)=>c['color'])))
    const [disabledColor, setDisabledColor] = useState(DISABLED_COLOR)


    // legend,  should be a dictionary
    const [curLegend, setCurLegend] = useState({})

    // force refresh
    const [forceRefresh,setForceRefresh] = useState(0)


    //stroke width coefficient
    const strokeWidthK = 0.13

    // default protein stroke width:
    const proteinDefaultWidth = 1.0

    // should be list of dictionaries
    const [trackOperations,setTrackOperations] = useState([])
    const [undoOperations,setUndoOperations] = useState([])
    // const [visibleTracks,setVisibleTracks] = useState()

    // legend related
    const [legendMeta,setLegendMeta] = useState("")
    const [showLegend,setShowLegend] = useState(false)

    var trackWidth = 2000 * widthLevel


    // const plotWidth = d3.select("#chartPlot").attr("width")

    var scale_value = data.length / scale;

    // list of integers
    var selectedTracks = [];

    // "translate(100,0) scale(0.5)"
    // const initialTrans = {'x':100,'y':0,'k':0.5}
    const [initialTrans,setInitialTrans] = useState({'x':200,'y':0,'k':0.5})

    const [curTree,setCurTree] = useState('')

    const [spicesNames,setSpicesNames] = useState([])
    const [curHighlight, setCurHighlight] = useState([])
    // var spicesNames = []
    // ************************************************************************************************************
    // ************************************************************************************************************

    // console.log(data)
    document.body.style.overscrollBehaviorX = 'none'

    const showNotImplement =()=>{
        Store.addNotification({
            // title: "",
            message: "Feature not implemented yet",
            type: "danger",
            insert: "top",
            container: "top-left",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
                duration: 2000,
                onScreen: true
            }
        });
    }


    function annotations2str(annotation_list){
        if(!annotation_list){
            return 'None'
        }
        // console.log(annotation_list)
        if(Object.keys(annotation_list).length === 0){
            return 'None'
        }

        let sortedList = Object.keys(annotation_list).sort();
        // Concatenate the array elements with a comma
        return sortedList.join(',');

    }


    function get_tex_width(txt, font) {
        const a = document.createElement('canvas');
        const c = a.getContext("2d");
        c.font = font;
        return c.measureText(txt).width;
    }


    function legendDraw() {

        if(!showLegend){
            d3.select("#legendPlot").attr('height',0)
            d3.selectAll("#legend").remove()
            return
        }

        // const chartPlot = d3.select("#chartPlot");
        const chartPlot = d3.select("#legendPlot");


        // console.log(chartPlot)

        var recWidth = chartPlot.attr('width')

        // padding between legend and chartplot
        var basePadding = 5

        var recHeight = 30
        chartPlot.attr('height',recHeight+5)

        d3.selectAll("#legend").remove()

        const legend = chartPlot
            .append('g')
            .attr('id','legend')

        // const plot = d3.select("#legend");
        // plot.call(legendTip);

        legend.append('rect')
            .attr('x', 1.5)
            // .attr('y', svgHeight - recHeight-1.5)
            .attr('y', basePadding)
            .attr('width', recWidth-3)
            .attr('height', recHeight)
            .attr("rx", 3)
            // .attr('stroke', '#87CEEB')
            .attr('stroke', '#007bff')
            .attr('stroke-width','2')
            // .attr('fill', '#FFFFFF')
            .attr('fill', '#FFFFFF')
            .attr('opacity',1.0);

        legend.append('circle')
            .attr("alignment-baseline", "middle")
            .attr('cx', 7)
            .attr('cy', svgHeight - recHeight+2.5)
            .attr("fill", "white")
            .attr('r',6.9)
            // .attr('opacity',0.5)

        legend.append('text')
            .attr("class", "legendSwitch")
            .attr("alignment-baseline", "middle")
            .attr('x', 2.8)
            // .attr('y', svgHeight - recHeight+ 3.6)
            .attr('y', basePadding)
            .attr('stroke', '#007bff')
            .style("font-size", textScale(20))
            .text("\u0058")
            // .text("\u24E7")
            .style("cursor", "pointer")
            .on('click',function (){

                // d3.selectAll("#legend").remove()
                setShowLegend(false)
                setCurLegend([])

                // setCurLegend([])
            });


        d3.selectAll("#drawLegends").remove()

        var interval = 4
        // var textInterval = 32
        var textInterval = 10


        var xBegin = 15;
        // var yBegin = svgHeight - recHeight + interval/2;
        var yBegin = basePadding;

        // var boundWidth = 20;
        // var boundHeight = 10;
        var fontAndHeight = 12
        var legendBlockHeight = 24

        // console.log(curLegend)
        //
        if(Object.keys(curLegend).length > 0){
            Object.keys(curLegend).map((key,value)=>{
                // let textWidth = get_tex_width(key, "13px Arial")

                let recWidth = 30


                const block = legend.append('g')
                    .attr('transform','translate('+xBegin.toString()+',' +
                        yBegin.toString()+')')
                    // .attr('x', xBegin)
                    // .attr("y", svgHeight - recHeight + interval / 2);

                block.append('rect')
                    .attr('id','legendBlock'+value.toString())
                    // .attr('x', xBegin)
                    // .attr("y", svgHeight - recHeight + interval / 2)
                    .attr('height', legendBlockHeight)
                    // .attr('stroke', '#000000')
                    .attr('stroke', '#007bff')
                    .attr('fill','none')
                    .attr('rx',3)
                    .attr('opacity',0.9);

                    // this is unicode


                block.append("rect")
                    .attr('id','rect'+value.toString())
                    .data(function (){

                        // use list since d3-v6-tip will use the first element
                        return [[curLegend[key],value]]
                    })
                    .attr('x', 16)
                    .attr('y', 4)
                    .attr('width', recWidth)
                    .attr('height', fontAndHeight)
                    // .attr("rx", 3)
                    .attr('stroke', '#000000')
                    // .attr('stroke', '#007bff')
                    .attr('fill', curLegend[key][0])
                    .attr('opacity',0.5)
                    // .on("mouseover", legendTip.show)
                    // .on("mouseout", legendTip.hide);


                block.append('circle')
                    .attr("alignment-baseline", "middle")
                    .attr('cx', 4.5)
                    .attr('cy', 4.8)
                    .attr("fill", "white")
                    .attr('r',6)
                    // .attr('opacity',0.8)

                block.append('text')
                    .attr("class", "legendSwitch")
                    .attr("alignment-baseline", "middle")
                    .attr('x', 1.5)
                    .attr('y', 5.7)
                    .attr('stroke', '#007bff')
                    .style("font-size", textScale(15))
                    .text("\u0058")
                    // .text("\u24E7")
                    .style("cursor", "pointer")
                    .on('click',function (){

                        const copyLegends = {...curLegend}
                        delete copyLegends[key]
                        setCurLegend(copyLegends)
                    });


                block.append("text")
                    .attr("x", recWidth + 24)
                    .attr("y", fontAndHeight+2)
                    .attr('id','test'+value.toString())
                    .text(key)
                    .style("font-size", fontAndHeight.toString()+"px")

                var textRect = d3.select("#test"+value.toString()).node().getBoundingClientRect();

                d3.select('#legendBlock'+value.toString())
                    .attr('width',textRect.width + recWidth + interval + textInterval + 14)

                // xBegin = xBegin + textWidth + recWidth + interval + textInterval


                xBegin = xBegin + textRect.width + recWidth + interval + textInterval + 18
                // console.log(textRect.width);
            })
        }

    }


    var trackOrder = [...Array(data.length).keys()]
    function performOperations(tracks){
        // console.log("perform")
        // console.log(trackOperations)
        // let trackOrder = [...Array(tracks.length).keys()]
        trackOrder = [...Array(tracks.length).keys()]

        tracks = tracks.map(item => {
            return {
                ...item,
                flip: false
            }
        });

        if(trackOperations.length === 0){
            // setKeepOrder(trackOrder)
            keepOrder = trackOrder
            return tracks
        }

        // let resultTracks = cloneDeep(tracks);
        let resultTracks = JSON.parse(JSON.stringify(tracks))

        let flipList = resultTracks.map((t)=>{
            return t['flip']
        })



        for (var i = 0; i < trackOperations.length; i++) {

            // we need backup tracks and moveXFlipList because the center sort only return the order of original tracks
            let backupTracks = JSON.parse(JSON.stringify(tracks))


            let operationType = Object.keys(trackOperations[i])[0]

            if(operationType === 'remove'){
                let targetTracks = trackOperations[i][operationType]

                let curKeepOrder = []

                // console.log('remove')
                let tmpOrderPrint= resultTracks.map(item=>{
                    return item['order']
                })
                // console.log(tmpOrderPrint)

                resultTracks = resultTracks.filter((t,index)=>{

                    // return targetTracks.indexOf(t['order'].toString()) <= -1
                    let curIdx = targetTracks.indexOf(t['order'])

                    // means not in remove list, then keep it
                    // curKeepOrder: index of not removed item
                    if(curIdx <= -1){
                        curKeepOrder = [...curKeepOrder,index]

                        return true
                    }
                    else{
                        return false
                    }
                })

                trackOrder = trackOrder.filter((t,index)=>{

                    // if we can find the index in curKeepOrder, then keep it
                    return curKeepOrder.indexOf(index) > -1;

                })




                for(let j =0; j < resultTracks.length;j++){
                    resultTracks[j]['order'] = j
                }
                let tmpOrder = resultTracks.map((d) => d.order)
                setOrders(tmpOrder)


                keepOrder = trackOrder
            }
            else if(operationType === 'drag'){
                // let nextOperation = Object.keys(trackOperations[i+1])[0]
                let targetOrder = trackOperations[i][operationType]
                resultTracks = targetOrder.map(index => resultTracks[index]);

                trackOrder = targetOrder.map(index => trackOrder[index]);

                for(let j =0; j < resultTracks.length;j++){
                    resultTracks[j]['order'] = j
                }
                let tmpOrder = resultTracks.map((d) => d.order)
                setOrders(tmpOrder)


            }
            // {'center':{'xdiff':[],'order':[]}
            else if(operationType === 'center'){

                let targetDict = trackOperations[i][operationType]

                let targetOrders = targetDict['order']

                //if xdiff is negative, reverse the track
                let targetXDiff = targetDict['xdiff']

                let targetOrientation = targetDict['orientation']
                // console.log(targetOrientation)
                //
                // console.log(targetXDiff)

                let restoreTracks = keepOrder.map(index => backupTracks[index])
                // let restoreTracks = trackOrder.map(index => backupTracks[index])



                resultTracks = targetOrders.map(index => restoreTracks[index]);
                // resultTracks = targetOrders.map(index => resultTracks[index]);
                // resultTracks = keepOrder.map(index => tracks[index]);
                let moveXFlipList = resultTracks.map((t,idx)=>{

                    let max_value = Math.max(
                        ...t["genes"].map(
                            (protein) => {
                                return protein["end"]+ t["offset"];
                            }
                        )
                    );

                    return x(max_value)
                })

                // orientation -1 means reverse/flip
                for(let j =0; j < targetOrientation.length;j++){
                    // resultTracks[j] = flipTrack(resultTracks[j],targetOrientation[j])
                    if(targetOrientation[j] === -1){
                        resultTracks[j]['flip'] = true

                        if(resultTracks[j]['x']){
                            resultTracks[j]['x'] += moveXFlipList[j]
                            resultTracks[j]['x'] += x(Math.abs(targetXDiff[j]))
                        }
                        else{
                            resultTracks[j]['x'] = moveXFlipList[j] + x(Math.abs(targetXDiff[j]))
                        }


                    }
                }

                for(let j =0; j < targetXDiff.length;j++){
                    resultTracks[j]['xDiff'] = Math.abs(targetXDiff[j])
                }

                trackOrder = targetOrders.map(index => trackOrder[index]);
                // trackOrder = targetOrders


                for(let j =0; j < resultTracks.length;j++){
                    resultTracks[j]['order'] = j
                }
                let tmpOrder = resultTracks.map((d) => d.order)
                setOrders(tmpOrder)
            }
            else if(operationType === 'flip'){
                let targetFlip = trackOperations[i][operationType]

                // moveX should be 0 for initialization
                // moveXFlip is for offset when tracks are flipped
                let moveXFlipList = resultTracks.map((t,idx)=>{

                    let max_value = Math.max(
                        ...t["genes"].map(
                            (protein) => {
                                return protein["end"]+ t["offset"];
                            }
                        )
                    );

                    return x(max_value)
                })

                // if the orientation is 1, then -1, but need to subtract the length of track so that the
                // the track can move to left, this is because the scale(-1,1) function will flip the track
                // horizontally by the left most point, which is x=0
                // if the orientation is -1, then 1, need to add the length of track, so the scale(-1,1) will not
                // cause the displacement of tracks.
                // xDiff is used for track alignment
                if(resultTracks[targetFlip]['flip']){
                    resultTracks[targetFlip]['flip'] = false

                    if(resultTracks[targetFlip]['x']){
                        resultTracks[targetFlip]['x'] -= moveXFlipList[targetFlip]
                    }
                    else{
                        let tmpDiff = Math.abs(resultTracks[targetFlip]['xDiff'])
                        resultTracks[targetFlip]['x'] =  x(tmpDiff) - moveXFlipList[targetFlip]
                    }
                }
                else{
                    resultTracks[targetFlip]['flip'] = true
                    if(resultTracks[targetFlip]['x']){
                        resultTracks[targetFlip]['x'] += moveXFlipList[targetFlip]
                    }
                    else{
                        let tmpDiff = Math.abs(resultTracks[targetFlip]['xDiff'])
                        resultTracks[targetFlip]['x'] =  x(tmpDiff) + moveXFlipList[targetFlip]
                    }
                }
            }
            else if(operationType === 'moveX'){
                let targetMove = trackOperations[i][operationType]
                // console.log('flip')
                // console.log(targetFlip)

                // console.log(Object.keys(trackOperations[i]))

                let moveList = Object.keys(targetMove)
                // console.log(moveList)

                for(let j =0; j < moveList.length;j++){
                    // console.log(resultTracks[moveList[j]])
                    resultTracks[moveList[j]]['x'] = targetMove[moveList[j]]['offsetX']
                }
                // console.log(targetMove)

            }

            // post process, reset variables:


            // console.log('order')
            // console.log(trackOrder)
            // console.log(resultTracks)


        }


        // console.log(spicesNames)
        return resultTracks
    }

    function scaleBarDraw(){

        // scale bar:
        const scaleBar = d3.select('#scaleBar')
        scaleBar.selectAll("*").remove();
        scaleBar.append('text')
            .attr("x", 10)
            .attr("y", 20)
            .attr('id','scaleText')
            .text('Scale Bar (1kb)')
            .style("font-size", "12px")

        // let curTrans = parseTransform(d3.selectAll("#plot").attr('transform'));
        //
        // let curK = parseFloat(curTrans[3])


        // console.log(curK)

        // console.log(zoomLevel)
        // let scaleRectWidth = x(x(1000) - x(0)) * curK
        let scaleRectWidth = (x(1000) - x(0)) * zoomLevel
        scaleBar.append('rect')
            .attr('id','scaleRect')
            .attr('x','120')
            .attr('y',11)
            // .attr('transform',`scale(${curK})`)
            .attr('width',scaleRectWidth)
            .attr('height',y.bandwidth() /2)
            .attr('opacity',0.7)
    }


    function draw() {

        let count = 0
        // console.log('draw')
        // data.map((item)=>{
        //     console.log(item.genes)
        //     count += item.genes.length
        //     return item
        // })
        // console.log(count)
        // clear cur lengend list when change meta
        if(legendMeta !== meta.name){
            setCurLegend({})
            setLegendMeta(meta.name)
        }


        // console.log(curLegend)

        // setForceRefresh(false)
        const chartPlot = d3.select("#chartPlot");
        const plot = d3.select("#plot");

        // console.log('highlight')
        // console.log(curHighlight)
        //
        // if(curHighlight.length > 0){
        //     const highlightPlot = plot.selectAll(".tracks")
        //         .selectAll(".genomes")
        //         .selectAll(".proteins")
        //         .filter(()=>{
        //             return true
        //         })
        //         .style('stroke','red')
        //     console.log(highlightPlot)
        // }

        chartPlot.style('cursor','all-scroll')
        var visibleTracks = performOperations(data)

        // console.log('draw')
        console.log(visibleTracks)
        console.log(trackOperations)
        // console.log(curCenterGene)
        // console.log(visibleTracks)

        plot.call(tip);

        // use class to define the application type, currently used in tips
        plot.attr("class",recordType);

        plot.selectAll("*").remove();



        plot.selectAll(".tracks")
            // .data(data, function (track) {
            //     return track["order"];
            //     //return track
            // })
            .data(visibleTracks, function (track) {
                return track["order"];
                //return track
            })
            .join((enter) => {

                // var curTrackY = y(track["order"])
                //

                var trackEnter = enter
                    .append("g")
                    .classed("tracks", true)
                    .attr("id", function (track) {
                        return "trackID_" + track["order"];
                    })
                    .attr("y", function (track) {
                        return y(track["order"]);
                    });

                var genomeEnter = trackEnter
                    .append("g")
                    .attr("class", "genomes")
                    .classed("flip", false)
                    // .classed("flip", function (track){
                    //     if(track.hasOwnProperty('xDiff')) {
                    //         // if xdiff is smaller than 0 , means this track need to be flip
                    //         // used when user center sort the tracks
                    //         return track['xDiff'] < 0;
                    //
                    //         // event.x = offset;
                    //     }
                    //
                    // })
                    .attr("x", function (track) {
                        // var flip_value = d3.select(this).classed('flip')
                        // var offset = 0;
                        // if(track.hasOwnProperty('xDiff')) {
                        //     offset = x(track["offset"]+track['xDiff']);
                        //     // event.x = offset;
                        // }
                        // else{
                        //     offset = x(track["offset"]);
                        // }
                        //
                        //
                        // return track["x"] ? track["x"] + offset : offset;



                        var offset = 0;
                        if(track.hasOwnProperty('xDiff')) {
                            offset = x(Math.abs(track['xDiff']));
                            // event.x = offset;
                        }
                        else{
                            offset = 0;
                        }

                        let max_value = Math.max(
                            ...track["genes"].map(
                                (protein) => {
                                    return protein["end"]+ track["offset"];
                                }
                            )
                        );

                        if(track['flip']){
                            // if(track["x"]){
                            //     if(track["x"] !== 0){
                            //         return track["x"]
                            //     }
                            //     else{
                            //         return track["x"]+ x(max_value)
                            //     }
                            // }
                            // if(track["x"]  || track["x"]===0){
                            //     return track["x"]+ x(max_value)
                            // }
                            // else if(track["x"] !== 0){
                            //     return track["x"]
                            // }

                            return track["x"] ? track["x"] : offset;
                        }
                        else{
                            return track["x"] ? track["x"] : offset;
                        }
                        // return track["x"] ? track["x"] : offset;



                        // return track["x"] ? track["x"] + offset : offset;
                    })
                    .attr("transform", function (track) {
                        var offset = 0;


                        if(track.hasOwnProperty('xDiff')) {
                            offset = x(track['xDiff']);
                            // event.x = offset;
                        }
                        else{
                            offset = 0;
                        }


                        let max_value = Math.max(
                            ...track["genes"].map(
                                (protein) => {
                                    return protein["end"]+ track["offset"];
                                }
                            )
                        );

                        let scale_trans = "scale(1,1)"


                        if(track['flip']){
                            scale_trans = "scale(-1,1)"
                            return (
                                "translate(" +
                                (track["x"] ? track["x"] : offset) +
                                ",0)" + scale_trans
                            );

                        }
                        else{
                            return (

                                "translate(" +
                                (track["x"] ? track["x"] : offset) +
                                ",0)" + scale_trans
                            );
                        }
                        // return (
                        //
                        //     "translate(" +
                        //     (track["x"] ? track["x"] : offset) +
                        //     ",0)" + scale_trans
                        // );


                    });

                genomeEnter
                    .selectAll(".proteins")
                    .data(function (track) {
                        return track["genes"];
                    })
                    .join((enter) => {
                        var proteinEnter = enter
                            .append("polygon")
                            .classed("proteins", true)
                            .attr("points", function (protein) {

                                // var begin = x(protein["start"]);
                                // var end = x(protein["end"]);
                                // var width = x(
                                //     protein["end"] - protein["start"]
                                // );

                                var genome_object = d3.select(this).node()
                                    .parentNode.__data__;

                                var begin = x(protein["start"]+genome_object["offset"]);
                                var end = x(protein["end"]+genome_object["offset"]);
                                var width = x(
                                    protein["end"] - protein["start"]
                                );
                                if (width <= y.bandwidth() / 2) {
                                    if (protein["strand"] === 1) {
                                        return (
                                            begin +
                                            "," +
                                            y.bandwidth() +
                                            " " +
                                            end +
                                            "," +
                                            y.bandwidth() / 2 +
                                            " " +
                                            begin +
                                            ",0"
                                        );
                                    } else if (protein["strand"] === -1) {
                                        return (
                                            begin +
                                            "," +
                                            y.bandwidth() / 2 +
                                            " " +
                                            end +
                                            "," +
                                            y.bandwidth() +
                                            " " +
                                            end +
                                            ",0"
                                        );
                                    }
                                } else {
                                    if (protein["strand"] === 1) {
                                        return (
                                            begin +
                                            "," +
                                            y.bandwidth() +
                                            " " +
                                            (end - y.bandwidth() / 2) +
                                            "," +
                                            y.bandwidth() +
                                            " " +
                                            end +
                                            "," +
                                            y.bandwidth() / 2 +
                                            " " +
                                            (end - y.bandwidth() / 2) +
                                            ",0 " +
                                            begin +
                                            ",0"
                                        );
                                    } else if (protein["strand"] === -1) {
                                        return (
                                            begin +
                                            "," +
                                            y.bandwidth() / 2 +
                                            " " +
                                            (begin + y.bandwidth() / 2) +
                                            "," +
                                            y.bandwidth() +
                                            " " +
                                            end +
                                            "," +
                                            y.bandwidth() +
                                            " " +
                                            end +
                                            ",0 " +
                                            (begin + y.bandwidth() / 2) +
                                            ",0"
                                        );
                                    }
                                }
                            })
                            // .attr("opacity", 0.5)
                            .attr("opacity", 0.5)
                            .style("fill", function (protein) {
                                // console.log(protein[meta["identifier"]])
                                // let Disabled_list = ['None','NA']

                                // meta: {data: Array(28), identifier: 'KEGG', name: 'KEGG', value: 'KEGG'}
                                // meta.data: 0 {color: '#40bf5e', count: 12, identifier: 'K00399', label: 'K00399'}
                                let Disabled_list = ['None','NA']
                                // console.log(protein)
                                let annotation_str = annotations2str(protein['annotations'][meta['identifier']])


                                if(Disabled_list.indexOf(annotation_str) !== -1){
                                    return DISABLED_COLOR
                                }
                                if(annotation_str.length === 0){
                                    return DISABLED_COLOR
                                }

                                var color = meta["data"].find((meta_object) => {
                                    // if(meta_object["identifier"]== None)
                                    // console.log(meta_object)

                                    return (
                                        meta_object["identifier"] ===
                                        // protein[meta["identifier"]]
                                        annotation_str
                                    );
                                });
                                if (color) {
                                    return color["color"];
                                }
                                return DISABLED_COLOR;
                            })
                            .style("stroke",function(){
                                var protein_object = d3.select(this).datum();

                                var genome_object = d3.select(this).node()
                                    .parentNode.__data__;
                                // console.log(genome_object)

                                if(curHighlight.indexOf(protein_object['gene']) > -1){
                                    return 'red'
                                }


                                let curColor = "grey"

                                // curCenterGene is used on manually center sort
                                if(genome_object.hasOwnProperty('search_center') && curCenterGene.length === 0 ){

                                    if(protein_object['gene'].replaceAll(" ", "") === genome_object['search_center'][0]
                                        && (genome_object['search_center'][0]).length !== 0){
                                        return "black"
                                        // curColor = "black"
                                    }
                                    else{
                                        return "black"
                                        // return null
                                    }

                                }
                                else{
                                    let curAnnotationId = annotations2str(protein_object['annotations'][
                                        meta["identifier"]
                                        ])


                                    if(curAnnotationId === curCenterGene){
                                        // curColor = "black"
                                        return "black"
                                    }
                                    else{
                                        return "black"
                                        // return null
                                    }

                                }
                            })
                            .style("stroke-width",function(){

                                var genome_object = d3.select(this).node()
                                    .parentNode.__data__;
                                var protein_object = d3.select(this).datum();
                                var strokeWidth = y.bandwidth() * strokeWidthK;

                                if(curHighlight.indexOf(protein_object['gene']) > -1){
                                    return strokeWidth.toString()
                                }


                                if(genome_object.hasOwnProperty('search_center') && curCenterGene.length === 0 ){

                                    if(protein_object['gene'].replaceAll(" ", "") === genome_object['search_center'][0]
                                        && (genome_object['search_center'][0]).length !== 0){
                                        return strokeWidth.toString()
                                    }
                                    else{
                                        return proteinDefaultWidth.toString()
                                        // return null
                                    }
                                }
                                else{
                                    let curAnnotationId = annotations2str(protein_object['annotations'][
                                        meta["identifier"]
                                        ])

                                    if(curAnnotationId === curCenterGene){
                                        return strokeWidth.toString()
                                    }
                                    else{
                                        return proteinDefaultWidth.toString()
                                        // return null
                                    }
                                }

                            })
                            .on("click", function (event){
                                event.preventDefault();
                                var protein_object = d3.select(this).datum();
                                var cur_stroke = d3.select(this).style('stroke')

                                if(cur_stroke === 'black') {

                                    genomeEnter
                                        .selectAll(".proteins")
                                        .filter(function (protein) {
                                            // console.log(genomeEnter)

                                            // if (protein_object['annotations'][meta["identifier"]] ===
                                            //     protein['annotations'][meta["identifier"]]){
                                            //     console.log(protein)
                                            //     console.log(protein_object['annotations'][meta["identifier"]],
                                            //         protein['annotations'][meta["identifier"]])
                                            // }


                                            // return annotations2str(protein_object['annotations'][meta["identifier"]]) ===
                                            //     annotations2str(protein['annotations'][meta["identifier"]])
                                            if(annotations2str(protein_object['annotations'][meta["identifier"]]) ===
                                                annotations2str(protein['annotations'][meta["identifier"]])){

                                                setCurHighlight((prevState)=>{
                                                    return [...prevState, protein['gene']]
                                                })

                                                return true

                                            }
                                            return false


                                        })
                                        .style("stroke", "red")
                                        .style("stroke-width", y.bandwidth() * strokeWidthK);
                                }
                                else{
                                    genomeEnter
                                        .selectAll(".proteins")
                                        .filter(function (protein) {

                                            if(annotations2str(protein_object['annotations'][meta["identifier"]]) ===
                                                annotations2str(protein['annotations'][meta["identifier"]])){

                                                setCurHighlight(prevItems => prevItems.filter(item => item !== protein['gene']));
                                                return true
                                            }
                                            return false

                                        })
                                        .style("stroke", "black")
                                        // .style("stroke-width", y.bandwidth() * strokeWidthK);
                                        .style("stroke-width", proteinDefaultWidth.toString())
                                }

                            })
                            .on("mouseover", tip.show)
                            .on("mouseout", tip.hide)
                            // .on('mouseover',(event,d)=>{
                            //     console.log('yea')
                            //     // tip.show(event,d);
                            // })
                            // .on("mouseout", function (event){
                            //     return tip.hide()
                            // })
                            .on("contextmenu", function (event) {
                                event.preventDefault();

                                var protein_object = d3.select(this).datum();
                                var genome_object = d3.select(this).node()
                                    .parentNode.__data__;

                                var annotation_id = annotations2str(protein_object['annotations'][
                                    meta["identifier"]
                                    ])

                                // visibleTracks
                                var menu_items = [
                                    {
                                        title:
                                            "Center on " + annotation_id,
                                            // protein_object["product"],
                                        action: () => {
                                            // centerCallback({
                                            //     center: protein_object[
                                            //         meta["identifier"]
                                            //     ],
                                            //     meta: meta["identifier"],
                                            // });
                                            // var localOrders = [...Array(visibleTracks.length).keys()].reverse()
                                            // setOrders(localOrders)
                                            // setForceRefresh(prevState => prevState+1)

                                            // console.log('keeporder')
                                            // console.log(keepOrder)

                                            // let curCenter = protein_object[
                                            //         meta["identifier"]
                                            //     ]
                                            let curCenter = annotation_id

                                            let curMeta = meta["identifier"]

                                            var formData = new FormData();
                                            formData.append("token", token)

                                            // console.log(curCenter)
                                            // center gene id, eg: id_glycosylating_toxin_TcdA
                                            formData.append("center", curCenter)

                                            // center gene key, eg: product_id
                                            formData.append("meta", curMeta)

                                            // some track maybe removed by user,
                                            formData.append("keepOrder", keepOrder)

                                            setCurCenterGene(curCenter)
                                            // add loading
                                            centerCallback({isLoad:true,center:curCenter})

                                            axios.post(SERVER_URL + "/api/center", formData)
                                                .then((response) => {
                                                    // setTrackData(response.data)

                                                    // console.log(response.data)

                                                    // let trackData = response.data.data
                                                    let trackOrder = response.data.order
                                                    let xDiffList = response.data.xdiff
                                                    let orientationList = response.data.orientation

                                                    centerCallback(false, curCenter)

                                                    let centerDict = {'center':
                                                            {
                                                                'order':trackOrder,
                                                                'xdiff':xDiffList,
                                                                'orientation':orientationList
                                                            }}
                                                    // setTrackOperations(prevState => {
                                                    //     return [...prevState,centerDict]
                                                    // })

                                                    if(trackOperations.length === 0){
                                                        setTrackOperations(prevState => {
                                                            return [...prevState,centerDict]
                                                        })
                                                        setForceRefresh(prevState => prevState+1)
                                                        return
                                                    }

                                                    let lastOperation = trackOperations[trackOperations.length - 1]
                                                    let operationType = Object.keys(lastOperation)[0]
                                                    // console.log(operationType)
                                                    if(operationType === 'center') {
                                                        let newArray = trackOperations.slice(0, trackOperations.length - 1);
                                                        newArray = [...newArray, centerDict];
                                                        setTrackOperations(newArray)
                                                        //
                                                        //         setTrackOperations(prevState => {
                                                        //             return [...prevState,orderDict]
                                                        //         })
                                                        //     }


                                                    }
                                                    else{
                                                        setTrackOperations(prevState => {
                                                            return [...prevState,centerDict]
                                                        })
                                                    }

                                                    setForceRefresh(prevState => prevState+1)

                                                })
                                                .catch((e) => {
                                                    console.log("ERROR")
                                                    console.log(e)
                                                    centerCallback(false, curCenter)
                                                    alert("No other genes exist")
                                                })

                                        },
                                    },
                                    {
                                        title:
                                            "Change color for " +
                                            annotation_id,
                                        action: () => {

                                            let annotation_str = annotations2str(protein_object['annotations'][meta['identifier']])
                                            var color = meta["data"].find((meta_object) => {
                                                // if(meta_object["identifier"]== None)
                                                // console.log(meta_object)

                                                return (
                                                    meta_object["identifier"] ===
                                                    // protein[meta["identifier"]]
                                                    annotation_str
                                                );
                                            });

                                            // var color = meta["data"].find((meta_object) => {
                                            //     return (
                                            //         meta_object["identifier"] ===
                                            //         protein_object[meta["identifier"]]
                                            //     );
                                            // });

                                            // console.log(color)
                                            if (color) {
                                                setCurColor(color['color'])
                                                setCurColorGene(color['identifier'])
                                            }
                                            else{

                                                setCurColor(DISABLED_COLOR)
                                                setCurColorGene("")
                                            }
                                            var pos = [d3.pointer(event, chartPlot.node())[0],
                                                d3.pointer(event, chartPlot.node())[1],width]

                                            setColorPickerPosition(pos)
                                            setShowColorPicker(true)


                                            // alert(
                                            //     "Feature not implemented yet"
                                            // );

                                            //showNotImplement()
                                        },
                                    },
                                    {
                                        title:
                                            "Add " +
                                            // protein_object["product"],
                                            annotation_id + " to legend",
                                        action: () => {

                                            setShowLegend(true)
                                            // console.log(protein_object)
                                            // var legendColor = meta["data"].find((meta_object) => {
                                            //     return (
                                            //         meta_object["identifier"] ===
                                            //         protein_object[meta["identifier"]]
                                            //     );
                                            // });

                                            let annotation_str = annotations2str(protein_object['annotations'][meta['identifier']])
                                            var legendColor = meta["data"].find((meta_object) => {
                                                return (
                                                    meta_object["identifier"] ===
                                                    // protein[meta["identifier"]]
                                                    annotation_str
                                                );
                                            });



                                            if (legendColor) {
                                                let infoList = [legendColor['color']]
                                                var LegendKey = legendColor['label']
                                                // setCurLegend({...curLegend,LegendKey:legendColor['color']})
                                                // setCurLegend(prevState => { return {...prevState,[LegendKey]:legendColor['color']}})
                                                setCurLegend(prevState => { return {...prevState,[LegendKey]:infoList}})

                                            }


                                        },
                                    },
                                    // {
                                    //     title:"Remove all legends",
                                    //     action:(event) =>{
                                    //         setCurLegend({})
                                    //     }
                                    // },
                                    {
                                        title: "Flip track",
                                        action: (event) => {
                                            // var offset = x(
                                            //     genome_object["offset"]
                                            // );
                                            console.log("Flip track")
                                            // console.log(visibleTracks)
                                            var currentFlip = genome_object["flip"]
                                            var offset = x(
                                                genome_object["xDiff"]
                                            );

                                            let flipOrder = genome_object['order']
                                            // var tmp_offset = Math.abs(genome_object["offset"])
                                            // var offset = -x(
                                            //     tmp_offset
                                            // );
                                            // var max_value = Math.max(
                                            //     ...genome_object["genes"].map(
                                            //         (protein) => {
                                            //             return protein["end"];
                                            //         }
                                            //     )
                                            // );
                                            var max_value = Math.max(
                                                ...genome_object["genes"].map(
                                                    (protein) => {
                                                        return protein["end"]+ genome_object["offset"];
                                                    }
                                                )
                                            );
                                            var translateX = parseSvg(
                                                d3
                                                    .select(this.parentNode)
                                                    .attr("transform")
                                            )["translateX"];

                                            // if (
                                            //     d3
                                            //         .select(this.parentNode)
                                            //         .classed("flip")
                                            // ) {
                                            if (
                                                currentFlip
                                            ) {
                                                // d3.select(
                                                //     this.parentNode
                                                // ).classed("flip", false);

                                                genome_object["flip"] = false


                                                d3.select(this.parentNode).attr(
                                                    "x",
                                                    translateX -
                                                    x(max_value)
                                                );
                                                d3.select(this.parentNode).attr(
                                                    "transform",
                                                    `translate(${
                                                        translateX -
                                                        x(max_value) 
                                                    }, 0) scale(1,1)`
                                                );

                                                let orderDict = {'flip':flipOrder}

                                                setTrackOperations(prevState => {
                                                    return [...prevState,orderDict]
                                                })
                                            } else {
                                                // d3.select(
                                                //     this.parentNode
                                                // ).classed("flip", true);

                                                genome_object["flip"] = true

                                                d3.select(this.parentNode).attr(
                                                    "x",
                                                    translateX +
                                                        x(max_value)
                                                );
                                                d3.select(this.parentNode).attr(
                                                    "transform",
                                                    `translate(${
                                                        translateX +
                                                        x(max_value) 
                                                    }, 0) scale(-1,1)`
                                                );
                                                // d3.select(this.parentNode).attr(
                                                //     "x",
                                                //     translateX +
                                                //     x(max_value)
                                                // );
                                                // d3.select(this.parentNode).attr(
                                                //     "transform",
                                                //     `translate(${
                                                //         translateX +
                                                //         x(max_value)
                                                //     }, 0) scale(-1,1)`
                                                // );


                                                let orderDict = {'flip':flipOrder}

                                                setTrackOperations(prevState => {
                                                    return [...prevState,orderDict]
                                                })
                                                // console.log('flip begin')
                                                // console.log(trackOperations)
                                                // setForceRefresh(prevState => prevState+1)

                                            }
                                        },
                                    },
                                    {
                                        title: "Show protein sequence",
                                        action: () => {


                                            const insertNewLines = (inputText) => {
                                                let result = '';
                                                for (let i = 0; i < inputText.length; i += 100) {
                                                    // Extract a substring of up to 130 characters and add a newline
                                                    result += inputText.substring(i, i + 100) + '\n';
                                                }
                                                return result;
                                            };

                                            // console.log(protein_object)
                                            var gtdb_id = genome_object['gtdb_id']
                                            // var gene_id = protein['gene-id']
                                            var gene_id = protein_object['gene']

                                            if(gene_id){
                                                gene_id = gene_id.trim()
                                            }

                                            var trans = protein_object['translation']

                                            if(trans){
                                                setSeq(insertNewLines(trans))
                                                setOpen(true)
                                                return

                                            }

                                            function checkStringFormat(inputString) {
                                                const pattern = /^\w+\.\d+_\d+$/;
                                                return pattern.test(inputString);
                                            }


                                            if(gene_id && checkStringFormat(gene_id)){
                                                // var queryString = gtdb_id + '&' + gene_id + '&' + curDatabase
                                                // let urlString = "/sequence#/?search&"+ queryString

                                                // window.open(urlString, "_blank");
                                                axios
                                                    .get(SERVER_URL + SEQ_SEARCH, {
                                                        params: {
                                                            gene_id:gene_id,
                                                            db:curDatabase
                                                        },

                                                    })
                                                    .then((response) => {
                                                        // setSeq(response.data)
                                                        setSeq(insertNewLines(response.data))
                                                        // console.log(response.data)
                                                        setOpen(true)

                                                    })
                                                    .catch(() => {
                                                        alert("Sequence Search Error");
                                                    });

                                            }

                                        },
                                    },
                                    {
                                        title: "Show annotation details",
                                        action: () => {
                                            // const detailsFormat =

                                            setMetaDetails({})
                                            let tempMetaDetail = {}

                                            const addDetails = (detailList) =>{
                                                detailList.map(item=>{
                                                    if(protein_object[item[0]]){
                                                        tempMetaDetail[item[1]] = protein_object[item[0]]
                                                    }
                                                })
                                            }

                                            function extractId(inputString) {
                                                // Regular expression to match the ID at the beginning of the string
                                                // Assumes IDs are composed of letters, digits, and underscores
                                                const regex = /^([A-Za-z0-9_]+)/;

                                                // Use the regex to find a match in the input string
                                                const match = inputString.match(regex);

                                                // match[0] contains the matched text if any match was found
                                                return match ? match[0] : null;
                                            }

                                            // proteinDetails: list of lists, [[key for gene,value for display]]
                                            let proteinDetails = [
                                                ['product','Genome'],
                                                ['start','Start'],
                                                ['end','End'],
                                                ['protein','Protein'],
                                            ]

                                            addDetails(proteinDetails)


                                            if(genome_object['track_meta']){

                                                genome_object['track_meta'].map((curMeta)=>{
                                                    tempMetaDetail[curMeta] = protein_object[curMeta]
                                                    // return {curMeta:protein_object[curMeta]}
                                                })
                                            }


                                            let annotations_result = ''

                                            // let uniProtDefaulUrl = 'https://alphafold.ebi.ac.uk/entry/A0A437R3H0'
                                            // let alphaFoldDefaultUrl = 'https://www.uniprot.org/uniprotkb/{cur_uniprot_id}/entry#structure'
                                            Object.keys(protein_object['annotations']).map((key,index)=>{


                                                // let curDatabase = key

                                                let annotation_list = Object.keys(protein_object['annotations'][key]).map((id,index)=>{

                                                    if(key.toLowerCase() === 'uniprot' && id){

                                                        let curUniprotID= extractId(id)
                                                        tempMetaDetail['Alphafold_Url'] = `https://alphafold.ebi.ac.uk/entry/${curUniprotID}`
                                                        tempMetaDetail['Uniprot_Url'] = `https://www.uniprot.org/uniprotkb/${curUniprotID}/entry#structure`
                                                    }

                                                    // console.log(Object.keys(gene['annotations'][key]))
                                                    if(Object.keys(protein_object['annotations'][key]).length === 0){
                                                        return
                                                    }
                                                    if(protein_object['annotations'][key][id].length !== 0){
                                                        return id + " (" + protein_object['annotations'][key][id] + ")"
                                                    }
                                                    else{
                                                        return id
                                                    }
                                                })

                                                // annotations_result = annotations_result + annotation_str + "</span><br>"
                                                tempMetaDetail[key] = annotation_list.filter(Boolean).join(', ')
                                            })

                                            setMetaDetails(tempMetaDetail)
                                                // setDetailOpen(true)
                                            setDetailOpen(true)

                                        },
                                    },
                                    // {
                                    //     title: "More details",
                                    //     action: () => {
                                    //         // alert(
                                    //         //     "Feature not implemented yet"
                                    //         // );
                                    //         showNotImplement();
                                    //     },
                                    // },
                                ];

                                // ContextMenu({
                                //     x: d3.pointer(event, plot.node())[0],
                                //     y: d3.pointer(event, plot.node())[1],
                                //     items: menu_items,
                                //     svg_width: width
                                // });
                                FixedSizeContextMenu({
                                    x: d3.pointer(event, chartPlot.node())[0],
                                    y: d3.pointer(event, chartPlot.node())[1],
                                    items: menu_items,
                                    svg_width: width
                                });

                            });


                        return proteinEnter;
                    });



                if (filter) {

                    console.log('filter!!')
                    console.log(filter)
                    genomeEnter
                        .selectAll(".proteins")
                        .filter(function (protein) {
                            var filterIdentifier = filter.map((x) => {
                                return x["identifier"];
                            });
                            return filterIdentifier.includes(
                                // protein[meta["identifier"]]
                                annotations2str(protein['annotations'][meta["identifier"]])
                            );
                        })
                        .style("stroke", "red")
                        .style("stroke-width", y.bandwidth() * strokeWidthK);
                }

                var labelEnter = trackEnter
                    .append("g")
                    .classed("labels", true)
                    .style("cursor", "pointer")
                    .on("mouseover", function () {
                        if (d3.select(this).select("rect").classed("checked")) {
                            d3.select(this)
                                .select("rect")
                                .style("fill", PRIMARY_COLOR);
                        } else {
                            d3.select(this)
                                .select("rect")
                                .style("fill", "rgb(200,200,200)");
                        }
                    })
                    .on("mouseout", function () {
                        if (d3.select(this).select("rect").classed("checked")) {
                            d3.select(this)
                                .select("rect")
                                .style("fill", PRIMARY_COLOR);
                        } else {
                            d3.select(this)
                                .select("rect")
                                .style("fill", "#fff");
                        }
                    })
                    .on("click", function () {
                        // if current track is selected:

                        let genomeObject = d3.select(this).node()
                            .parentNode.__data__;
                        let curOrder = genomeObject['order']

                        if (d3.select(this).select("rect").classed("checked")) {
                            d3.select(this)
                                .selectAll("rect")
                                .classed("checked", false)
                                .style("fill", "#fff");
                            d3.select(this)
                                .selectAll("text")
                                .style("fill", "#000");

                            // let trackID = d3.select(this).node()
                            //     .parentNode.id;



                            // format: trackid_#
                            // trackID = trackID.slice(8)
                            // setSelectedTracks(prevState =>
                            //     prevState.filter(item => {
                            //         //  remove object that has id equal to 2
                            //         return item !== trackID;
                            //     }),
                            // );


                            selectedTracks = selectedTracks.filter(item=>{
                                    return item !== curOrder;
                                }
                            )

                            // let curIdx = trackOrder.indexOf(curOrder)
                            // selectedTracks = selectedTracks.filter((item, idx)=>{
                            //         return idx !== curIdx;
                            //     }
                            // )

                            // selectedTracks = selectedTracks.filter(item=>{
                            //         return item !== trackID;
                            //     }
                            // )

                            // if current track is not selected
                        } else {
                            let genomeObject = d3.select(this).node()
                                .parentNode.__data__;
                            let curOrder = genomeObject['order']
                            // console.log(genomeObject)

                            d3.select(this)
                                .selectAll("rect")
                                .classed("checked", true)
                                .style("fill", PRIMARY_COLOR);
                            d3.select(this)
                                .selectAll("text")
                                .style("fill", "#fff");


                            var trackID = d3.select(this).node()
                                .parentNode.id;

                            // format: trackid_#
                            // trackID = trackID.slice(8)

                            // setSelectedTracks(prevState =>{
                            //     return [...prevState,[trackID]]
                            // })
                            // selectedTracks = [...selectedTracks,trackID]


                            // let curIdx = trackOrder.indexOf(curOrder)
                            // selectedTracks = [...selectedTracks,curIdx]
                            selectedTracks = [...selectedTracks,curOrder]
                            // console.log(selectedTracks)

                        }
                    })
                    .on("contextmenu", function (event) {
                        event.preventDefault();

                        const findIndexByKey = (items, key) => {
                            const reversedItems = [...items].reverse();
                            const index = reversedItems.findIndex(item => key in item);
                            return index !== -1 ? items.length - 1 - index : -1;
                        }

                        var menu_items = [
                            {
                                title: "Delete all selected tracks",
                                action: ()=>{

                                    let removeDict = {'remove':selectedTracks}
                                    setTrackOperations(prevState => {
                                        return [...prevState,removeDict]
                                    })

                                    setForceRefresh(prevState => prevState+1)


                                }
                            },
                            // should pop all until the operation is remove
                            {
                                title: "Undo",
                                action:()=>{
                                    let tempOperation = trackOperations
                                    // let lastOperation = tempOperation.pop()

                                    // console.log(trackOperations)
                                    let removeIdx = findIndexByKey(tempOperation,'remove')
                                    // console.log(removeIdx)

                                    if (removeIdx !== -1) {
                                        const newPoppedItems = tempOperation.slice(removeIdx);
                                        const newItems = tempOperation.slice(0, removeIdx);

                                        setTrackOperations(newItems)

                                        setUndoOperations(prevState => {
                                            return [...prevState,newPoppedItems]
                                        })
                                        setForceRefresh(prevState => prevState+1)
                                    }


                                }
                            },

                        ]
                        FixedSizeContextMenu({
                            x: d3.pointer(event, chartPlot.node())[0],
                            y: d3.pointer(event, chartPlot.node())[1],
                            items: menu_items,
                            svg_width: width
                        });
                    })





                labelEnter
                    .append("rect")
                    .attr("class", "boxes")
                    .classed("checked", false)
                    .attr("rx", 3)
                    .attr("ry", 3)
                    .attr("x", -10)
                    .attr("fill", "#fff")
                    .attr("height", y.bandwidth())
                    .style("stroke", "#CBCBCB")
                    .style("stroke-width", strokeWidthK);

                labelEnter
                    .append("rect")
                    .attr("class", "taxonomyBox")
                    .classed("checked", false)
                    .attr("rx", 3)
                    .attr("ry", 3)
                    // .attr("x", -100)
                    // .attr("x", -10 - labelOffset)
                    .attr("width",89)
                    .attr("fill", "#fff")
                    .attr("height", y.bandwidth())
                    .style("stroke", "#CBCBCB")
                    .style("stroke-width", strokeWidthK);

                if(recordType === "annotree_search" || recordType === 'gtdb_csv' || recordType === 'ncbi_csv'){
                    labelEnter
                        .append("text")
                        .classed("texts", true)
                        .attr("class","taxonomyText")
                        // .attr("x", -77)
                        .attr("alignment-baseline", "middle")
                        .attr("text-anchor", "start")
                        .attr("y", y.bandwidth() / 2)
                        .style("font-size", textScale(y.bandwidth()))
                        .text(function (track){
                            var curText = track["taxonomy"][trackTaxonomy]
                            if(curText)
                                return track["taxonomy"][trackTaxonomy]
                            else
                                // return "null"
                                return null
                        });
                }

                // labelEnter
                //     .append('polygon')
                //     .classed('moveLabels')
                //     .attr('fill',PRIMARY_COLOR)
                //     .attr('stroke','black')
                //     .attr('stroke-width',0.1)

                labelEnter
                    .append("text")
                    .attr("class", "fa burgers")
                    .attr("y", y.bandwidth() / 2)
                    // .attr("x", -95)
                    .attr("alignment-baseline", "middle")
                    // .attr("fill", "#000")
                    .attr("fill", "#7b7f7fff")
                    .style("font-size", textScale(y.bandwidth()))
                    // .text("\uf0c9")

                    // this is unicode
                    .text("\u21F3")
                    .style("cursor", "row-resize");
                    // .style("cursor", "move");

                labelEnter
                    .append("text")
                    .attr("class", "fa leftRightMoveLabels")
                    .attr("y", y.bandwidth() / 2)
                    // .attr("x", -95)
                    .attr("alignment-baseline", "middle")
                    // .attr("fill", "#000")
                    .attr("fill", "#7b7f7fff")
                    .style("font-size", textScale(y.bandwidth()))
                    // .text("\uf0c9")
                    .text("\u2B04")
                    // .text("\u00bf")
                    .style("cursor", "col-resize");




                labelEnter
                    .append("text")
                    .classed("texts", true)
                    .attr("x", 1.5 * textScale(y.bandwidth()))
                    .attr("alignment-baseline", "middle")
                    .attr("text-anchor", "start")
                    .attr("y", y.bandwidth() / 2)
                    .style("font-size", textScale(y.bandwidth()))
                    .text(function (track) {
                        // var curText = track["taxonomy"][trackTaxonomy]
                        // if(curText)
                        //     return track["taxonomy"][trackTaxonomy]
                        // else
                        //     return "null"
                        return track['organism']
                    });

                function sizeLabel() {
                    var labelOffset;
                    var z = d3
                        .selectAll(".texts")
                        .nodes()
                        .map(function (x) {
                            return x.getBBox();
                        });
                    labelOffset =
                        d3.max(
                            z.map(function (x) {
                                return x.width;
                            })
                        ) + 60;

                    var TaxLabelOffset;
                    var zTax = d3
                        .selectAll(".taxonomyText")
                        .nodes()
                        .map(function (x) {
                            return x.getBBox();
                        });
                    TaxLabelOffset =
                        d3.max(
                            zTax.map(function (x) {
                                return x.width;
                            })
                        ) + 60;

                    // code below is used to cut off genes
                    // console.log(labelOffset)
                    // d3.selectAll(".tracks")
                    //     .append("rect")
                    //     .classed("proteins", true)
                    //     .attr("x", function (){
                    //         return -labelOffset-510
                    //     })
                    //     .attr("y", function (){
                    //         return 0
                    //     })
                    //     .attr("width", function (){
                    //         return 500
                    //     })
                    //     .attr("height", function (){
                    //         return y.bandwidth()
                    //     })
                    //     .attr("fill", "white")


                    if(recordType === "annotree_search" || recordType === 'gtdb_csv'||  recordType === 'ncbi_csv') {
                        d3.selectAll(".fa.burgers")
                            .attr("x", -TaxLabelOffset - 3)


                        //     .html("\uf0c9");

                        d3.selectAll(".taxonomyText").attr("x", -TaxLabelOffset+15);

                        d3.selectAll(".taxonomyBox")
                            .attr("width", TaxLabelOffset)
                            .attr("x",-10-TaxLabelOffset);
                    }
                    else{
                        d3.selectAll(".fa.burgers")
                            .attr("x", -5)
                        d3.selectAll(".taxonomyText").attr("x", 0);

                        d3.selectAll(".taxonomyBox")
                            .attr("width", 0)
                            .attr("x",0);
                    }

                    d3.selectAll(".fa.leftRightMoveLabels").attr("x", labelOffset-27)


                    d3.selectAll(".boxes").attr("width", labelOffset);



                    d3.selectAll(".tracks").attr("transform", function (track) {
                        return (
                            "translate(" +
                            (labelOffset + 15) +
                            "," +
                            y(track["order"]) +
                            ")"
                        );
                    });
                    d3.selectAll(".labels").attr("transform", function (track) {
                        return "translate(" + -labelOffset + ",0)";
                    });
                }

                sizeLabel();
                return trackEnter;
            });


    }

    const colorPickerCallback = (oldColor, newColor) =>{

        // var tempColorSet = colorSet
        // if(tempColorSet.has(newColor.hex)){
        //     alert("duplicated color, please try again")
        //     return
        // }
        // tempColorSet.delete(oldColor.hex)
        // tempColorSet.add(newColor.hex)
        // setColorSet(tempColorSet)

        d3.selectAll('.proteins').filter(protein=>{
            return annotations2str(protein['annotations'][meta['identifier']])=== curColorGene
            // return protein[meta['identifier']] === curColorGene
        })
            .style('fill',newColor.hex)

        var color = meta["data"].find((meta_object) => {

            return (
                meta_object["identifier"] ===
                curColorGene
            );
        });
        color['color'] = newColor.hex
        // console.log(color)

        setShowColorPicker(false)
    }

    const ordersCallback = (ords) => {
        // console.log(trackOperations)

        setOrders(ords)
        let orderDict = {'drag':ords}


        // if(trackOperations.length === 0){
        //     setTrackOperations(prevState => {
        //         return [...prevState,orderDict]
        //     })
        //
        //     setForceRefresh(prevState => prevState+1)
        //     return
        // }


        setTrackOperations(prevState => {
            return [...prevState,orderDict]
        })
        setForceRefresh(prevState => prevState+1)



        // setForceRefresh(prevState => prevState+1)
        // setOrders(ords);
    };

    //const x = d3.scaleLinear().domain([minValue, maxValue]).range([0, 5000]);
    const x = d3.scaleLinear().domain([0, maxValue]).range([0, trackWidth]);

    // const y = d3
    //     .scaleBand()
    //     .domain(orders)
    //     .range([0, height * scale_value])
    //     .padding(0.1);


    const y = d3
        .scaleBand()
        .domain(data.map((d) => d.order))
        .range([0, height * scale_value])
        .padding(0.1);

    const textScale = d3
        .scaleLinear()
        .domain([1, 180])
        .range([1, 100])
        .clamp(true);

    // useEffect(() => {
    //     // setOrders(data.map((d) => d.order));
    //     draw();
    //     // setOrders(data.map((d) => d.order));
    // }, [data, filter, meta, scale,trackTaxonomy]);

    useEffect(() => {

        // setOrders(data.map((d) => d.order));
        draw();
        // setOrders(data.map((d) => d.order));
    }, [data, filter, meta, scale,trackTaxonomy,forceRefresh]);

    useEffect(()=>{
        scaleBarDraw();
    }, [zoomLevel]);

    useEffect(() => {
        // console.log(zoomLevel)
        // setOrders(data.map((d) => d.order));
        let plotTrans = d3.selectAll('#plot').attr('transform')
        let curTrans = parseTransform(plotTrans)
        let curX = curTrans[1]
        let curY = curTrans[2]
        let curK = curTrans[3]

        let newTrans = "translate(" + curX + "," + curY + ") scale(" + zoomLevel.toString() + ")"
        d3.selectAll('#plot').attr('transform',newTrans)

        // setOrders(data.map((d) => d.order));
    }, [zoomLevel]);


    useEffect(() => {
        // console.log(zoomLevel)
        // setOrders(data.map((d) => d.order));
        // console.log("track")
        // console.log(zoomLevel)
        // console.log(widthLevel)
        if(trackWidth >= svgWidth * 2){
            setSvgWidth(prevState => {return prevState * 1.5 })
        }

        // console.log("svg")
        // console.log(svgWidth)
        scaleBarDraw()
        draw()

        // setOrders(data.map((d) => d.order));
    }, [widthLevel]);

    useEffect(() => {

        // setOrders(data.map((d) => d.order));
        legendDraw()
        // setOrders(data.map((d) => d.order));
    }, [curLegend]);


    const dragCallback = (offsetX,curOrder, orientation) => {
        console.log('drag')
        console.log(offsetX)

        // let offsetDict = {offsetX,curOrder}
        let tmpDict = {}
        tmpDict[curOrder] = {'offsetX':offsetX, 'flip':orientation}
        let offsetDict = {'moveX':tmpDict}
        // let offsetDict = {'moveX':{'move':tmpDict,'flip': orientation}}


        if(trackOperations.length === 0){
            setTrackOperations(prevState => {
                return [...prevState,offsetDict]
            })
            // setForceRefresh(prevState => prevState+1)
            return
        }

        let lastOperation = trackOperations[trackOperations.length - 1]
        let operationType = Object.keys(lastOperation)[0]
        // console.log(operationType)
        if(operationType === 'moveX') {
            let newArray = trackOperations.slice(0, trackOperations.length - 1);
            // let lastMove = lastOperation[operationType]
            let lastMove = lastOperation[operationType]


            // lastMove[curOrder] = offsetX
            lastMove[curOrder] =  {'offsetX':offsetX, 'flip':orientation}
            // offsetDict = {'moveX':lastMove}
            offsetDict = {'moveX':lastMove}

            newArray = [...newArray, offsetDict];
            setTrackOperations(newArray)
            //
            //         setTrackOperations(prevState => {
            //             return [...prevState,orderDict]
            //         })
            //     }


        }
        else{
            setTrackOperations(prevState => {
                return [...prevState,offsetDict]
            })
        }



        // if(trackOperations.length === 0){
        //     setTrackOperations(prevState => {
        //         return [...prevState,orderDict]
        //     })
        //
        //     setForceRefresh(prevState => prevState+1)
        //     return
        // }
        // setForceRefresh(prevState => prevState+1)

    };

    Drag({ x: x, effect: [filter, meta],dragCallback:dragCallback });
    // Drag({ x: x, effect: [filter, meta],strokeWidth:y.bandwidth() * strokeWidthK });
    // Order({
    //     y: y,
    //     orders: orders,
    //     height: height,
    //     effect: [filter, meta],
    //     ordersCallback: ordersCallback,
    // });

    Order({

        // this follows the calculation of range in const y function
        y_range: orders.length / scale * height,
        orders: orders,
        height: height,
        effect: [filter, meta, orders],
        ordersCallback: ordersCallback,
    });

    const handleScroll = (event) => {
        // console.log(scrollTop)
        // let moveX = 0
        // let moveY = 0
        // setScrollTop(event.currentTarget.scrollTop);
        // setScrollLeft(event.currentTarget.scrollLeft);

        // let legendTrans = "translate(" + scrollLeft + "," + scrollTop + ")"
        // d3.selectAll("#legend").attr('transform',legendTrans)

        setScrollTop(event.currentTarget.scrollTop);
        setScrollLeft(event.currentTarget.scrollLeft);
        // setScrollTop(event.currentTarget.scrollTop);
    };

    // Zoom({ ref: svgRef, curZoom ,initialTrans});

    // useEffect(() => {
    //     if(relocate > 0){
    //
    //     }
    // }, [relocate]);

    const parseTransform =(trans)=>{
        let regex = new RegExp(/translate\((.*)\,(.*)\) scale\((.*)\)/)

        return trans.match(regex);
    }

    const zoom = d3.zoom()
        .extent([[0, 0], [svgWidth, svgHeight]])
        .scaleExtent([0.01, 8])
        .on("zoom", function (event) {

            let curX = initialTrans['x'] + event.transform.x
            let curY = initialTrans['y'] + event.transform.y
            let curK = initialTrans['k'] * event.transform.k

            var curTrans = "translate("+curX+","+curY+
                ") scale("+curK+")"
            // console.log(curTrans)
            // d3.selectAll("#plot").attr('transform', event.transform);
            d3.selectAll("#plot").attr('transform', curTrans );
            // d3.selectAll("#chartPlot").attr('transform', curTrans );
        })

    // useEffect(() => {
    //     const svg = d3.select(svgRef.current);
    //     // svg.call(zoom);
    // }, [svgRef])

    const SvgDrag = d3.drag()
        .on("drag",function (event,panel){
            // console.log('drag..')
            let curTrans = parseTransform(d3.selectAll("#plot").attr('transform'));
            let curX = parseFloat(curTrans[1])
            let curY = parseFloat(curTrans[2])
            let curK = parseFloat(curTrans[3])

            let XAfterDrag = curX + event.dx
            let YAfterDrag = curY + event.dy

            // console.log(document.getElementById("chart").scrollTop)

            d3.selectAll("#plot").attr('transform',`translate(${
                XAfterDrag
            },${YAfterDrag}) scale(${curK})`)
        })

    d3.selectAll("#chartPlot").call(SvgDrag);


    useEffect(() => {
        if(visionMode === 1){
            if(relocate > 0){
                d3.selectAll("#chartPlot").transition()
                    .duration(750)
                    .call(zoom.transform, d3.zoomIdentity);

            }
        }{
            let curTrans = parseTransform(d3.selectAll("#plot").attr('transform'));
            let curX = parseFloat(initialTrans['x'])
            let curY = parseFloat(initialTrans['y'])
            let curK = curTrans[3]

            let newTrans = "translate("+curX +"," + curY+ ") scale("+curK+ ")"
            d3.selectAll("#plot").attr('transform',newTrans)
            // document.getElementById("chart").scrollTop = curY
            // document.getElementById("chart").scrollLeft = curX


            document.getElementById("chart").scrollTop = 0
            document.getElementById("chart").scrollLeft = 0
        }

    }, [relocate]);


    useEffect(() => {
        // if vision mode = 1, then drag, if vision mode = 0, then scroll bar
        // console.log(visionMode)
        const svg = d3.select(svgRef.current);
        if(visionMode === 1){

            svg.call(zoom);
            // document.getElementById("chart").style.overflowX = 'hidden'
            // document.getElementById("chart").style.overflowY = 'hidden'

            document.getElementById("chart").style.overflowX = 'clip'
            document.getElementById("chart").style.overflowY = 'clip'
        }
        else{

            svg.on('.zoom', null);

            document.getElementById("chart").style.overflowX = 'scroll'
            document.getElementById("chart").style.overflowY = 'scroll'
        }
    }, [visionMode]);


    function handleClose(){
        setShowColorPicker(false)
    }


    const ScrollSvgHeight = ()=>{
        let curHeight = (y.bandwidth()) * data.length * 0.8
        if(curHeight <= svgHeight){
            curHeight = svgHeight+ 100
        }
        return curHeight
    }

    function isValidHttpUrl(string) {
        let url;

        try {
            url = new URL(string);
        } catch (_) {
            return false;
        }

        return url.protocol === "http:" || url.protocol === "https:";
    }

    return (
        <div>

            <div>

                <TrackBase id="chart" onScroll={handleScroll}>

                    <svg id="chartPlot" ref={svgRef} width={svgWidth} height={ScrollSvgHeight()}>
                    {/*<svg id="chartPlot" ref={svgRef} width={svgWidth*10} height={svgHeight*10}>*/}
                        {/*<g id="plot" transform={"translate(100,0) scale(0.5)"}></g>*/}
                        <g id="plot" transform={"translate("+initialTrans['x']+","+initialTrans['y']+
                            ") scale("+initialTrans['k']+")"}></g>
                        {/*<g id="plot" transform={"translate(" + plotTransX + "," + plotTransY +") scale(" + plotTransScale + ")"}></g>*/}

                    </svg>

                    {/*<svg id="legendPlot" ref={svgRef} width={svgWidth*2} height={ScrollSvgHeight()}>*/}
                    {/*    /!*<g id="plot" transform={"translate("+initialTrans['x']+","+initialTrans['y']+*!/*/}
                    {/*    /!*    ") scale("+initialTrans['k']+")"}></g>*!/*/}
                    {/*    <g id="legend" ></g>*/}
                    {/*</svg>*/}


                </TrackBase>
                <div>
                    <svg id="legendPlot" width={svgWidth}>
                        {/*<g id="plot" transform={"translate("+initialTrans['x']+","+initialTrans['y']+*/}
                        {/*    ") scale("+initialTrans['k']+")"}></g>*/}
                        <g id="legend" ></g>
                    </svg>
                    <svg id="scaleBar" width={svgWidth} height={40}>

                    </svg>
                </div>


            </div>
            { showColorPicker ?
                <div>
                    <div className={'cover'} style={ {
                        position: 'fixed',
                        top: '0px',
                        right: '0px',
                        bottom: '0px',
                        left: '0px',
                    } } onClick={ handleClose }/>
                    <CustomizedColorPicker positionLeft={colorPickerPosition[0]}
                                           positionTop={colorPickerPosition[1]}
                                           pickerWidth={colorPickerPosition[2]}
                                           originColor={curColor}
                                           showCallback={colorPickerCallback}/>
                </div>: null
            }
            <Popup open={open} lockScroll closeOnDocumentClick onClose={closeModal}>
                <div className="modal">
                    <a className="close" onClick={closeModal}>
                        &times;
                    </a>
                    <div style={{'overflowY': 'auto','maxHeight': '300px',}}>
                        {/*<p style={{'worBreak': 'break-all'}}>*/}
                        {/*    {seq}*/}
                        {/*</p>*/}
                        {seq}
                    </div>



                </div>
            </Popup>
            <Popup open={treeOpen} closeOnDocumentClick onClose={closeTreeModal}>
                <div className="modal">
                    <a className="close" onClick={closeTreeModal}>
                        &times;
                    </a>

                    {/*<div className={"Phylotree"}>*/}
                    {/*    <PhyloTree treeFile={curTree}/>*/}
                    {/*</div>*/}

                    {/*<div className={"Phylotree"}>*/}
                    {/*    <PhylogeneticTree treeFile={curTree}/>*/}
                    {/*</div>*/}

                    {/*<img src={`data:image/png;base64,${curTree}`} />*/}
                    <img src={curTree} alt={'a'}/>


                </div>
            </Popup>
            <Popup open={detailOpen} closeOnDocumentClick onClose={closeDetailModal}
                   >
                <div className="modal">
                    <a className="close" onClick={closeDetailModal}>
                        &times;
                    </a>
                    <div style={{'wordBreak': 'break-all'}}>
                        <h6>Annotation Details:</h6>

                        <div>
                        {

                            Object.entries(metaDetails).map(([key,value])=>{
                                if (key.includes('Url') && isValidHttpUrl(value)) {
                                    return (
                                        <div><strong>{key}</strong>:
                                            <a href={value} target="_blank" rel="noopener noreferrer"
                                               style={{ color: '#1E66E5',textDecoration: 'underline'}}>{value}</a></div>
                                    )
                                }
                                else{
                                    if(value.length!==0){
                                        return (
                                            <div><strong>{key}</strong>:{value}</div>
                                        )
                                    }

                                }

                            })
                        }
                        </div>
                    </div>

                </div>
            </Popup>
        </div>
        );
};

export default Tracks;
